import { LinkedinRequestsInputFilters } from "domain/models/linkedinrequests-input-filter";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { LinkedinRequests } from "domain/entities/linkedinrequests";
import { ILinkedinRequestsRepository } from "domain/contracts/linkedinrequests.contracts";
import {
  LinkedinRequestsPayload,
  UpdateInput,
} from "domain/entities/linkedinrequests";

class LinkedinRequestsRepository implements ILinkedinRequestsRepository {
  async getAll(
    filter: LinkedinRequestsInputFilters,
  ): Promise<Message<LinkedinRequests[]>> {
    const response = await httpClient.get(`/positionRequests`, {
      params: filter,
    });
    return response.data;
  }
  async getById(id: string): Promise<Message<LinkedinRequests>> {
    const response = await httpClient.get(`/positionRequests/${id}`);
    return response.data;
  }
  async create(
    input: LinkedinRequestsPayload,
  ): Promise<Message<LinkedinRequests>> {
    const response = await httpClient.post(`/positionRequests`, {
      data: input,
    });
    return response.data;
  }
  async delete(id: string): Promise<Message<Boolean>> {
    const response = await httpClient.delete(`/positionRequests/${id}`);
    return response.data;
  }
  async update(input: UpdateInput): Promise<Message<boolean>> {
    const { id } = input;
    const response = await httpClient.put(`/positionRequests/${id}`, {
      data: input,
    });
    return response.data;
  }
}

export default new LinkedinRequestsRepository();
